<div *ngIf="headlines && headlines.length" class="headlines">
    <a
        *ngFor="let heading of headlines"
        class="headline"
        href="{{url}}#{{heading.dataset.anchor}}"
        [ngClass]="{
            'headline--active': heading.dataset.anchor === activeAnchor
        }"
        [innerHTML]="heading.dataset.text"
    ></a>
</div>
